
import { Component, Vue } from 'vue-property-decorator';
import { taskExportList } from '@/api/orderService';
import { closeTask } from "@/api/taskExport"
import { UserModule } from '@/store/modules/user';
import { parseTime } from '../../utils';

@Component({
  name: 'FilesExportTask',
  filters: {
    formatDate(val: string) {
      if (val === '' || parseInt(val) === 0) {
        return '';
      }
      return parseTime(parseInt(val), '');
    }
  }
})
export default class extends Vue {
  private tableData = []
  private timeCountId:any='';
  created() {
    this.taskExportList();
    if (!this.timeCountId) {
      this.timeCountId = setInterval(() => {
        this.taskExportList();
      }, 5000);
    }
  }
  private getTaskType(val:any) {
    let str:string = '';
    if (val.task_name) {
      return val.task_name;
    }
    switch (parseInt(val.task_type)) {
      case 11:
        str = '报修单导出';
        break;
      case 12:
        str = '报修单统计导出';
        break;
      case 21:
        str = '服务单导出';
        break;
      case 22:
        str = '投诉单导出';
        break;
      case 31:
        str = '任务导出';
        break;
      case 40:
        str = '备件导出';
        break;
      case 45:
        str = '库存导出';
        break;
      case 46:
        str = '出入库记录导出';
        break;
      case 44:
        str = '库存统计导出';
        break;
      case 47:
        str = '库存个人统计导出';
        break;
      case 48:
        str = '库存客户统计导出';
        break;
      case 49:
        str = '盘点记录导出';
        break;
      case 50:
        str = '图片导出';
        break;
      case 52:
        str = '订单图片导出';
        break;
      case 57:
        str = '订单电子工单导出';
        break;
      case 60:
        str = '考勤记录导出';
        break;
      case 71:
        str = '点检统计导出';
        break;
      case 72:
        str = '点检二维码导出';
        break;
      case 76:
        str = '点检记录导出';
        break;
      case 81:
        str = '统计报表导出';
        break;
      case 85:
        str = '设备统计导出';
        break;
      case 87:
        str = '故障现象/故障类型统计导出';
        break;
      case 91:
        str = '自定义报表导出';
        break;
      case 100:
        str = '人员统计导出';
        break;
      case 101:
        str = '人员任务统计导出';
        break;
      case 103:
        str = '工程师统计导出';
        break;
      case 110:
        str = '看板导出';
        break;
      case 120:
        str = '客户列表导出';
        break;
      case 121:
        str = '客户二维码导出';
        break;
      case 122:
        str = '客户统计导出';
        break;
      case 123:
        str = '客户统计详情导出';
        break;
      case 210:
        str = '部门导出';
        break;
    }
    return str;
  }
  private cancleExportTask(val:any) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.id = val.id
    closeTask(params).then((res:any) => {
      this.showSecussMsg(res.msg)
    }).catch(err => {
      let msg = err.msg
      this.showErrorMsg(msg)
    })
  }
  private taskExportList() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    taskExportList(params).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      clearInterval(this.timeCountId);
      let msg = err.msg;
    });
  }
  destroyed() {
    clearInterval(this.timeCountId);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
